export const OrganizationalChart = {
  path: '/organizational_charts',
  name: 'organizational_charts',
  component: () => import('@/views/OrganizationalChart/OrganizationalChartPage.vue'),
  children: [
    {
      path: '/organizational_charts/add/parent/:parentId',
      name: 'organizational_charts.add',
      component: () => import('@/views/OrganizationalChart/Form/OrganizationalChartForm.vue'),
      props: { addAction: true }
    },
    {
      path: '/organizational_charts/edit/:id',
      name: 'organizational_charts.edit',
      component: () => import('@/views/OrganizationalChart/Form/OrganizationalChartForm.vue'),
      props: {updateAction: true}
    },
    {
      path: '/organizational_charts/delete/:id',
      name: 'organizational_charts.delete',
      component: () => import('@/views/OrganizationalChart/Form/OrganizationalChartForm.vue'),
      props: {deleteAction: true}
    },
  ],
}